module.exports = __webpack_public_path__ + "img/baodaoti_zhihuiyungang.2f9d1ead.png";